import { useMutation, useQueryClient } from '@tanstack/react-query';
import { attachProductToPlan, detachProductFromPlan } from '../services/plans';

export const planProductsQueryKey = (planId: string) => ['smr-admin', 'plan-products', planId];

export function usePlanProductMutations(planId: string) {
    const queryClient = useQueryClient();

    const invalidate = () => queryClient.invalidateQueries({ queryKey: planProductsQueryKey(planId) });

    return {
        attachMutation: useMutation({
            mutationFn: (productId: string) => attachProductToPlan(planId, productId),
            onSuccess: invalidate,
        }),
        detachMutation: useMutation({
            mutationFn: (productId: string) => detachProductFromPlan(planId, productId),
            onSuccess: invalidate,
        }),
    };
}
